
import Vue from 'vue';
import { defineComponent } from 'vue';
import Common from './BannersCommon.vue';
import VueObserveVisibility from 'vue-observe-visibility';
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";

Vue.use(VueObserveVisibility);

export default defineComponent({
    extends: Common,
    computed: {
        device():DeviceType{
            return DeviceType.desktop
        }
    }
});
